<template>
    <div>
        <div ref="searchProdutoModal" class="modal fade search-produto-modal-stack" id="searchProdutoModal"
            role="dialog" aria-labelledby="searchProdutoModal" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-slideout" role="document" style="max-width:90%!important;">
                <div class="modal-content h-100 overflow-auto">
                    <div class="modal-header d-flex justify-content-between pb-0">
                        <h5 class="modal-title mt-2" id="modal-title">Pesquisar Produto</h5>
                        <div>
                            <button @click="check('Enter')" type="button" class="btn text-lg text-primary">
                                <i class="bi bi-check-lg"></i>
                            </button>
                            <button type="button" class="btn text-lg text-danger" data-bs-dismiss="modal"
                                aria-label="Close">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        </div>
                    </div>
                    <div class="modal-body" id="modal-body">
                        <div class="row">

                            <div class="col-md-9">
                                <div class="input-group mb-3">
                                    <input v-on:keyup="find($event.key)" v-on:keydown="check($event.key)"
                                        v-model="search" type="text" id="productSearch" ref="productSearch"
                                        name="productSearch" placeholder="Nome ou código..." class="form-control"
                                        autocomplete="off">
                                </div>
                                <div v-show="loading" class="spinner-border text-primary" role="status"
                                    style="display:none;"><span class="sr-only">Loading...</span>
                                </div>
                                <select v-if="produtos.length" @change="render($event.target.selectedIndex)"
                                    v-on:keydown="setOnKeyDown($event.target.selectedIndex, $event.key)"
                                    @dblclick="setOnDblClick($event)" ref="selectProdutos" id="selectProdutos"
                                    name="selectProdutos" class="form-select custom-select p-0" size="7">
                                    <option v-for="(produto, index) in produtos" :key="index"
                                        :selected="index == 0 ? 'selected' : false" class="border-bottom p-1"
                                        :data-index="index">{{ produto.name }}</option>
                                </select>
                                <div v-show="loadingMore" class="spinner-border text-primary" role="status"
                                    style="display:none;">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <p v-show="nobody" class="text-center" style="display:none;">
                                    Nenhum resultado encontrado! <br>
                                    <i class="far fa-frown text-xg"></i>
                                </p>
                            </div>

                            <div v-if="produto" class="col-md-3 d-flex align-items-center justify-content-center">
                                <div v-show="photoUrl == null" class="spinner-border text-primary" role="status"
                                    style="display:none;"><span class="visually-hidden"></span></div>
                                <img v-show="photoUrl" ref="photo" class="img-fluid mb-3" :src="photoUrl"
                                    style="display:none;">
                            </div>

                            <div v-if="produto" class="col-md-12 mt-3">
                                <div class="row d-flex justify-content-center">

                                    <div v-if="isAdmin" class="col-md-6 text-end">
                                        <a :href="'/cadastro/produtos/track/' + produto.id" target="_blank"
                                            class="btn btn-secondary me-2">
                                            <i class="bi bi-diagram-3-fill"></i> Rastrear
                                        </a>
                                        <a :href="'/cadastro/produtos/edit/' + produto.id" target="_blank"
                                            class="btn btn-primary me-2">
                                            <i class="bi bi-pencil-square"></i> Editar
                                        </a>
                                    </div>

                                    <div class="col-12">
                                        <div v-if="!produto.active" class="col-md-12 alert alert-danger">
                                            <h3 class="mb-0">Produto Inativo</h3>
                                        </div>
                                    </div>
                                    <div class="col-md-9">
                                        <table class="table table-sm mb-3">
                                            <tbody>
                                                <tr>
                                                    <td class="border-0" width="25%">{{ produto.id }}</td>
                                                    <td class="border-0"><span class="badge bg-primary">INTERNO</span>
                                                    </td>
                                                </tr>
                                                <tr v-for="(codigo, id, index) in produto.codigos" :key="index">
                                                    <td>{{ codigo.code }}</td>
                                                    <td v-if="codigo.isOriginal"><span
                                                            class="badge bg-warning">ORIGINAL</span></td>
                                                    <td v-else-if="codigo.empresa" class="text-sm text-primary">{{
                                                        codigo.empresa.name }}</td>
                                                    <td v-else class="text-sm text-danger">DESCONHECIDO</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div v-if="produto.observacao" class="card p-3 w-100 mb-3">
                                            <h4 class="mb-0">Observação</h4>
                                            <hr>
                                            <div class="w-100" v-html="produto.observacao"></div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <p class="text-end mb-1 border-bottom">
                                            <span class="text-primary text-sm clearfix">Preço</span>
                                            <span class="">{{ produto.preco_venda | decimal }}</span>
                                        </p>
                                        <p v-if="showCusto && !showRealCost" class="text-end mb-1 border-bottom">
                                            <span class="text-primary text-sm clearfix">Custo</span>
                                            <span>{{ (produto.custo_para_vendas ?? produto.preco_custo) | decimal
                                            }}</span>
                                        </p>
                                        <p v-if="showRealCost" class="text-end mb-1 border-bottom">
                                            <span class="text-primary text-sm clearfix">Custo Real</span>
                                            <span>{{ produto.preco_custo | decimal
                                            }}</span>
                                        </p>
                                        <p class="text-end mb-1 border-bottom">
                                            <span class="text-primary text-sm clearfix">Estoque / Localização</span>
                                            <span v-for="(estoque, index) in produto.estoques"
                                                class="d-flex justify-content-between align-items-center bg-blue-100 mb-1 rounded px-2 py-1">
                                                <span class="text-sm text-primary">{{ estoque.company.rotulo }}</span>
                                                <span>{{ estoque.saldo | integer }}
                                                    <span class="badge bg-warning text-dark ms-2">{{ estoque.localizacao
                                                        }}</span>
                                                </span>
                                            </span>
                                        </p>
                                        <p class="text-end mb-1 border-bottom">
                                            <span class="text-primary text-sm clearfix">Unidade</span>
                                            <span v-if="produto.unidade">{{ produto.unidade.sigla }}</span>
                                        </p>
                                        <p id="produtoCategorias">

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--<button type="button" class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#searchProdutoModal"><i class="fas fa-box-open"></i> Abrir Produto <span class="shortcut-key">(F1)</span></button>-->

    </div>
</template>

<script>
export default {

    props: {
        showCusto: {},
        onlyActives: {},
        isVue: {},
        isPedido: {},
        isAdmin: {},
        showRealCost: {
            type: Boolean,
            default: false
        },
        includeMlOnly: {
            type: Boolean,
            default: false
        }
    },

    mounted() {
        //console.log('ProductSearch is Loaded');
        setTimeout(() => {
            this.$refs.productSearch.focus();
        }, 500);
    },

    data() {
        return {
            search: '',
            timestamp: null,
            skip: 0,
            take: 30, // Não use um número inferior à 50
            trigger: 15, // Não use um número inferior à 40
            clear: true,
            loadingMore: false,
            lastLote: 0,
            modal: false,
            loading: false,
            photoUrl: null,
            produtos: [],
            produto: null,
            selected: null,
            finding: false,
            findCount: 0,
            lastString: ''
        };
    },

    computed: {
        nobody() {
            if (!this.findCount) {
                return false;
            }

            if (this.produtos.length || this.loading) {
                return false;
            }

            if (this.finding) {
                return false;
            }

            return true;
        }
    },

    methods: {

        check(key) {

            if (key === 'ArrowRight' || key === 'ArrowLeft') {
                return false;
            }

            if (key === 'ArrowDown') {
                if (!this.produtos.length) {
                    return false;
                }
                let index = this.$refs.selectProdutos.selectedIndex + 1;
                if (index == this.produtos.length) {
                    return false;
                }
                this.$refs.selectProdutos[index].selected = true;
                return this.render(index);
            }

            if (key === 'ArrowUp') {
                if (!this.produtos.length) {
                    return false;
                }
                let index = this.$refs.selectProdutos.selectedIndex - 1;
                if (index < 0) {
                    return false;
                }
                this.$refs.selectProdutos[index].selected = true;
                return this.render(index);
            }

            if (key === 'Enter') {
                let index = this.$refs.selectProdutos.selectedIndex;
                return this.set(index);
            }
        },

        find(key) {
            if (key === 'ArrowRight' || key === 'ArrowLeft' || key === 'ArrowDown' || key === 'ArrowUp' || key === 'Enter') {
                return false;
            }
            let string = this.search;
            this.produtos = [];
            this.produto = null;
            if (string.length < 3) {
                return;
            }
            this.finding = true;
            setTimeout(() => { this.findFilter(string) }, 500);
        },

        findFilter(string) {
            if (string === this.search) {
                this.loading = true;
                this.clear = true;
                this.skip = 0;
                this.findCount++;
                this.lastString = this.search;
                var form = {
                    search: this.search,
                    onlyActives: this.onlyActives,
                    includeMlOnly: this.includeMlOnly,
                    skip: this.skip,
                    take: this.take
                };
                setTimeout(() => { this.findRequest(form), 500 });
            }
        },

        findRequest(form) {
            form.timestamp = this.timestamp = moment().unix();
            //console.log('http://localhost:8000/cadastro/produtos/search?search=' + this.search + '&skip=' + this.skip + '&take=' + this.take);
            axios
                .post('/cadastro/produtos/search', form)
                .then(response => (this.findResponse(response.data)))
                .catch(error => {
                    console.log(error);
                    this.loading = false;
                    this.loadingMore = false;
                    this.finding = false;
                });
        },

        findResponse(data) {

            if (data.timestamp != this.timestamp) {
                return false;
            }

            this.lastLote = data.data.length;

            if (this.clear) {
                this.produtos = [];
                this.skip = 0;
            }

            for (var i = 0; i < data.data.length; i++) {
                this.produtos.push(data.data[i]);
                //console.log(data.data[i].name)
            }

            //console.log('Registros: ', this.lastLote)

            if (this.clear && this.produtos.length) {
                this.render(0);
            }

            this.skip += this.take;
            this.loading = false;
            this.loadingMore = false;

            return false;
        },

        getMore(index) {

            if (this.lastLote < this.take) {
                return false; // Acabou
            }

            if (this.loadingMore) {
                return false; // Já existe um processo
            }

            if (index + this.trigger >= this.produtos.length) {
                this.loadingMore = true;
                this.clear = false;
                var form = {
                    search: this.search,
                    onlyActives: this.onlyActives,
                    includeMlOnly: this.includeMlOnly,
                    skip: this.skip,
                    take: this.take
                };
                return this.findRequest(form);
            }
        },

        render(index) {
            this.getMore(index);
            // Produto
            this.produto = this.produtos[index];
            this.loading = false;
            this.finding = false;

            // Foto
            this.photoUrl = null;
            let produtoId = this.produto.id;
            setTimeout(() => { this.renderImage(produtoId) }, 100);
        },

        renderImage(produtoId) {
            if (!this.produto || produtoId != this.produto.id) {
                return false;
            }

            const src = this.produto.photoUrl;
            const placeholder = 'https://fox.app.br/layouts/default/img/no-photo.png';
            if (!src) {
                this.photoUrl = placeholder;
                return false;
            }

            let myImage = new Image();
            myImage.onload = () => {
                if (!this.produto || produtoId != this.produto.id) {
                    return;
                }
                this.photoUrl = myImage.src;
            };
            myImage.onerror = () => {
                if (!this.produto || produtoId != this.produto.id) {
                    return;
                }
                // 403/404/NS_BINDING_ABORTED → placeholder; não trava a venda
                this.photoUrl = placeholder;
            };
            myImage.src = src;
        },

        setOnKeyDown(index, key) {

            if (key == 'Enter') {
                return this.set(index);
            }

            if (index == 0 && key == 'ArrowUp') {
                return this.$refs.productSearch.focus();
            }
        },

        setOnDblClick(event) {
            let index = event.explicitOriginalTarget.getAttribute('data-index');
            return this.set(index)
        },

        set(index) {
            if (index != null) {
                let selected = this.produtos[index];
                this.selected = selected;
                $('#searchProdutoModal').modal('toggle');
                return this.isVue
                    ? this.$parent.productSearchCallback(selected)
                    : productSearchCallback(selected);
            }
        },

    },

    filters: {
        decimal(value) {
            return (value === null) ? '' : parseFloat(value).toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        integer(value) {
            return (value === null) ? '' : parseFloat(value).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        datetime(value) {
            return (value) ? moment(value).at('DD/MM/YYYY HH:mm') : '-';
        }
    }

}
</script>

<style scoped>
/* Abre por cima de outro modal (ex.: assistente de integração NFe) */
.search-produto-modal-stack {
    z-index: 1100 !important;
}
</style>
